import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import CategoryContractor from './Category'
import CurrencyContractor from './Currency'
import PaymentContractor from './PaymentTerms'
import DeliveryContractor from './DeliveryTerms'
import TypeContractor from './Type'
import DesignationContractor from './Designation'
import StatusContractor from './Status'
import RatingContractor from './PerformanceRating'

function ContractorsSettings() {
    return(
        <>
        {/* <TextMediumSM content="Main Contractors" /> */}
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <CategoryContractor/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <TypeContractor/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <CurrencyContractor/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <PaymentContractor/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <DeliveryContractor/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <RatingContractor/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <DesignationContractor/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusContractor/>
         </div>
        
       
         </div>
         </>
    )
}

export default ContractorsSettings
